import { ReactElement } from 'react';
import ReactHtmlParser from 'react-html-parser';

export function fillTemplateWithColouredVariables(
  templateText: string,
  mappingArray: { variable: string; key: string }[],
  values: { [key: string]: string },
  valuesColor: string
): ReactElement | null {
  let templateReplaced = templateText;

  // Replace placeholders
  mappingArray.forEach(({ variable, key }) => {
    const value = values[key];
    if (typeof value === 'undefined') {
      console.error(`Value for key ${key} not found`);
    }
    templateReplaced = templateReplaced.replace(
      `{{${variable}}}`,
      `<span style="color:${valuesColor}">${value}</span>`
    );
  });

  return <>{ReactHtmlParser(templateReplaced)}</>;
}

export function fillTemplate(
  templateText: string,
  mappingArray: { variable: string; key: string }[],
  values: { [key: string]: string }
): string {
  let templateReplaced = templateText;

  // Replace placeholders
  mappingArray.forEach(({ variable, key }) => {
    const value = values[key];
    if (typeof value === 'undefined') {
      console.error(`Value for key ${key} not found`);
    }
    templateReplaced = templateReplaced.replace(`{{${variable}}}`, value);
  });

  return templateReplaced;
}
